export enum BootstrapAlertType {
    success = 'alert-success-oeny',
    info = 'alert-info-oeny',
    danger = 'alert-danger-oeny',
    warning = 'alert-warning-oeny'
}

export function ShowBootstrapAlertMessageOnPage(divSelector: string, alertType: BootstrapAlertType, message: string, classToAdd: string, haveToDelay: boolean = false) {
    $(divSelector).removeClass().addClass(`${classToAdd} alert ` + alertType).text(message).fadeTo(500, 1);

    if (haveToDelay) {
        $(divSelector).delay(4000).fadeTo(2000, 0);
    }
}
